import DismissibleBanner from "@magoosh/lib/dismissible_banner/template";
export default DismissibleBanner;
